<template>
  <div class="d-flex align-center">
    <div class="edit-month-picker-area" :class="{ full: !this.value }">
      <v-menu
        ref="targetDate"
        v-model="pickerFlag"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <input
            readonly
            v-model="dateFormatted"
            v-on="on"
            :style="inputWidth"
            style="text-align:center;height:100%"
            @blur="checkMonth"
          />
        </template>
        <v-date-picker
          v-model="date"
          locale="ja"
          no-title
          type="month"
          @input="pickerFlag = false"
        ></v-date-picker>
      </v-menu>
    </div>
    <v-btn
      v-show="value"
      style="width:22px; height:22px;"
      icon
      @click="$emit('input', null)"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "対象年月"
    },
    width: Number
  },

  data: vm => ({
    pickerFlag: false,
    formattingDate: vm.value
  }),

  watch: {
    value() {
      this.formattingDate = this.value;
    }
  },

  computed: {
    date: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.formattingDate = newValue;
        this.$emit("input", newValue);
      }
    },
    dateFormatted: {
      get() {
        if (!this.date) return null;
        const [year, month] = this.date.split("-");
        return `${year}年${month}月`;
      },
      set(newValue) {
        const regex = /^([0-9]+?)年([0-9]+?)月$/g;
        const result = regex.exec(newValue);
        if (result) {
          const year = result[1];
          const month = result[2];
          this.formattingDate =
            ("000" + year).slice(-4) + "-" + ("0" + month).slice(-2);
        }
      }
    },
    inputWidth() {
      if (this.width) {
        let inputW = this.width - 1;
        if (this.value) {
          inputW = this.width - 22 - 1;
        }
        return {
          width: inputW + "px;"
        };
      }
      return {};
    }
  },

  methods: {
    checkMonth() {
      this.$emit("input", this.formattingDate);
    }
  }
};
</script>

<style lang="scss">
.edit-month-picker-area {
  height: 100%;
  width: calc(100% - 22px);

  input {
    width: 100% !important;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  &.full {
    width: 100%;
  }
}
</style>
